__turbopack_context__.v({
  "root": "Placeholder-module__Rt8LQa__root",
});
